<template>
  <div v-if="tabs.length" class="tabs-link-container">
    <router-link v-for="(item, index) in tabs" :key="index" class="tabs-link" :to="item.path" active-class="cur">
      {{ item.label }}
    </router-link>
  </div>
</template>
<script>
  export default {
    name: 'FddTabs',
    props: {
      tabs: {
        type: Array,
        default: () => []
      }
    }
  }
</script>
<style scoped lang="less">
  @border: 1px solid #e6e8ea;

  .tabs {
    &-link {
      min-width: 120px;
      height: 32px;
      color: #2a2b2c;
      font-size: 12px;
      background: #ffffff;
      border-right: @border;
      border-top: @border;
      border-bottom: @border;
      display: flex;
      padding: 0 8px;
      align-items: center;
      justify-content: center;

      &-container {
        display: flex;

        & .cur {
          color: #ffffff;
          background: #276ef9;
          border-color: #276ef9 !important;
        }
      }

      &:first-child {
        border-radius: 5px 0 0 5px;
        border-left: @border;
      }

      &:last-child {
        border-radius: 0 5px 5px 0;
      }
    }
  }
</style>
